import React from "react";
import InsuranceList from "../../../../components/cases/assets/balanceOfAssets/insurance";

const Insurance = ({ next, back, tabText }) => {
  return (
    <>
      <InsuranceList next={next} back={back} />
      {/* <SuggestionBox
        mainText={tabText}
        tabName="Insurance"
        setVisited={visited}
      /> */}
    </>
  );
};

export default Insurance;
